export const CLEAR_INTEGRATION_PROVIDERS = "CLEAR_INTEGRATION_PROVIDERS";
export const LOAD_INTEGRATION_PROVIDERS = "LOAD_INTEGRATION_PROVIDERS";
export const LOAD_INTEGRATION_PROVIDERS_SUCCESS = "LOAD_INTEGRATION_PROVIDERS_SUCCESS";
export const LOAD_INTEGRATION_PROVIDERS_FAILURE = "LOAD_INTEGRATION_PROVIDERS_FAILURE";
